module.exports = __webpack_public_path__ + "media/images/lp/achievement5-pc-7c7ae0036b3ee94e23d02e8edd8037e2.png";